import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext, ToastrContext } from '../../contexts';
import IconAturBesaranSubsidi from '../../components/icons/IconAturBesaranSubsidi';
import ModalFormSubsidi from './ModalFormSubsidi';
import ModalDeleteConfirm from './ModalDeleteConfirm';
import EmptyStateSubsidi from './EmptyStateSubsidi';
import DataSubsidiContent from './DataSubsidiContent';
import {
  fetchInformasiBesaranSubsidi,
  fetchCreateInformasiBesaranSubsidi,
  fetchDeleteInformasiBesaranSubsidi,
  clearSubsidyMessage,
} from './actions';
import styles from './styles.scoped.css';

export default function InformasiBesaranSubsidi() {
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);

  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [targetDeleteId, setTargetDeleteId] = useState(null);
  const [selectedDeleteData, setSelectedDeleteData] = useState(null);

  const {
    activeData,
    historyList,
    isLoading,
    isLoadMoreLoading,
    isSubmitLoading,
    isDeleteLoading,
    meta,
    message,
    error,
    successSubmit,
    successDelete,
  } = useSelector((state) => state.informasiBesaranSubsidi || {});

  useEffect(() => {
    setBreadcrumbs([
      { name: 'Informasi Besaran Subsidi', to: '/subsidy-info' },
    ]);
    dispatch(fetchInformasiBesaranSubsidi({ page: 1, size: 100 }));
  }, [dispatch, setBreadcrumbs]);

  useEffect(() => {
    if (successSubmit) {
      setToastr({
        desc: message || 'Berhasil mengatur informasi besaran subsidi',
        type: 'success',
        visible: true,
      });
      setModalFormOpen(false);
      dispatch(clearSubsidyMessage());
    }
    if (successDelete) {
      setToastr({
        desc: message || 'Berhasil menghapus informasi besaran subsidi',
        type: 'success',
        visible: true,
      });
      setModalDeleteOpen(false);
      setTargetDeleteId(null);
      setSelectedDeleteData(null);
      dispatch(clearSubsidyMessage());
    }
    if (error) {
      setModalFormOpen(false);
      setModalDeleteOpen(false);
      setTargetDeleteId(null);
      setSelectedDeleteData(null);
      setToastr({
        desc: error,
        type: 'danger',
        visible: true,
      });
      dispatch(clearSubsidyMessage());
    }
  }, [successSubmit, successDelete, error, message, setToastr, dispatch]);

  const handleFormSubmit = (payload) => {
    dispatch(fetchCreateInformasiBesaranSubsidi(payload));
  };

  const handleOpenDelete = (item) => {
    setTargetDeleteId(item.id || item._id);
    setSelectedDeleteData(item);
    setModalDeleteOpen(true);
  };

  const handleConfirmDelete = () => {
    if (targetDeleteId) dispatch(fetchDeleteInformasiBesaranSubsidi(targetDeleteId));
  };

  const handleLoadMore = () => {
    if (isLoadMoreLoading || isLoading) return;
    const page = meta?.page || 1;
    const totalPage = meta?.totalPage || 1;

    if (page < totalPage) {
      dispatch(fetchInformasiBesaranSubsidi({ page: page + 1, size: 100 }, true));
    }
  };

  const isValidActiveData = Boolean(
    activeData && (activeData.id || activeData.status || activeData.startDate)
  );
  const hasData = Boolean(
    isValidActiveData || (historyList && historyList.length > 0)
  );

  let mainContent;
  if (isLoading) {
    mainContent = (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <p>Memuat data...</p>
      </div>
    );
  } else if (!hasData) {
    mainContent = (
      <EmptyStateSubsidi onOpenModal={() => setModalFormOpen(true)} />
    );
  } else {
    mainContent = (
      <DataSubsidiContent
        activeData={activeData}
        historyList={historyList}
        isLoadMoreLoading={isLoadMoreLoading}
        meta={meta}
        onLoadMore={handleLoadMore}
        onOpenDelete={handleOpenDelete}
      />
    );
  }

  return (
    <div className={styles.container}>
      {/* Top Bar Action Button */}
      <div className={styles.topCard}>
        <button
          className={styles.btnPrimaryGreen}
          onClick={() => setModalFormOpen(true)}
          type="button"
        >
          <IconAturBesaranSubsidi color="#fff" stroke="#5E811E" />
          Atur Informasi Besaran Subsidi
        </button>
      </div>

      {/* Main Content Area */}
      <div className={styles.mainCard}>
        {mainContent}
      </div>

      {/* Modals */}
      <ModalFormSubsidi
        historyList={historyList}
        isLoading={isSubmitLoading}
        onClose={() => setModalFormOpen(false)}
        onSubmit={handleFormSubmit}
        opened={modalFormOpen}
      />

      <ModalDeleteConfirm
        data={selectedDeleteData}
        isLoading={isDeleteLoading}
        onClose={() => setModalDeleteOpen(false)}
        onConfirm={handleConfirmDelete}
        opened={modalDeleteOpen}
      />
    </div>
  );
}
